import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import styles from "../../content/pages/homepage.module.css";
import RotoGPT from "../../assets/RotoGPT.png";
import { useNavigate } from "react-router";
import { useAuth0 } from "@auth0/auth0-react";
import { MenuWrapper, SubMenuWrapper } from "../../layouts/StyleWrapper";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
}

const drawerWidth = 180;

const navItems = [
  { label: "Home", path: "/" },
  // { label: "Pricing", path: "/pricing" }, //DESCOMENTAR CUANDO SE PRECISE PAGINA DE PRECIOS NUEVAMENTE
  { label: "Contact", path: "/contact" },
  // { label: "API Docs", path: `${process.env.REACT_APP_API_DOCUMENTATION}`, external: true }, //DESCOMENTAR CUANDO SE PRECISE PAGINA DE API DOCS NUEVAMENTE
  // { label: "Chat", path: `https://chat.rotogpt.com/`, external: true },
];
export default function NavBar(props: Props) {
  const { window: containerWindow } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const { loginWithRedirect, isAuthenticated } = useAuth0();

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  //Function to check if the tab is to open in an external window or not
  const handleNavClick = (path: string, external: boolean = false) => {
    if (external) {
      (window as any).open(path, "_blank");
    } else {
      navigate(path);
    }
    setMobileOpen(false);
  };

  // useEffect(() => {
  //   if (isAuthenticated) {
  //     navigate("/dashboard/home");
  //   }
  // }, [isAuthenticated, navigate]);

  const login = async () => {
    await loginWithRedirect({
      appState: { returnTo: "/dashboard/home" },
    });
  };

  const drawer = (
    //Add the same styles as the dashboard sidebar for mobile version:
    <MenuWrapper>
      <List component="div">
        <SubMenuWrapper>
          <Box p={2}>
            <a href="/">
              <img src={RotoGPT} alt="RotoGPT" width={100} />
            </a>
          </Box>
          <Divider sx={{ background: PureLightThemeCaaS.colors.alpha.trueWhite[30] }} />
          <List component="div">
            {/* AGREGAR external LUEGO DE LABEL,PATH CUANDO SE AGREGUE API DOCS */}
            {navItems.map(({ label, path }) => (
              <ListItem key={label}>
                {/* //AGREGAR EXTERNAL CUANDO SE AGREGUE API DOCS COMO PARAMETRO EN handleNavClick LUEGO DE PATH */}
                <Button sx={{ textAlign: "left", fontFamily: "Roboto, Arial" }} disableRipple onClick={() => handleNavClick(path)}>
                  {label}
                </Button>
              </ListItem>
            ))}
          </List>
        </SubMenuWrapper>
      </List>
    </MenuWrapper>
  );

  const container = containerWindow !== undefined ? () => containerWindow().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar component="nav">
        <Toolbar
          sx={{
            pr: 1,
            pl: 2,
            minHeight: "70px",
            backgroundColor: "#000000",
            boxShadow: "0px 0px 15px #333333",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={handleDrawerToggle} sx={{ pr: 0, mr: 0, display: { sm: "block", lg: "none" } }}>
            <MenuIcon fontSize="small" />
          </IconButton>
          <Box component="div" p={1.5} sx={{ flexGrow: 1, display: { sm: "none", lg: "block", xs: "none" } }}>
            <a href="/">
              <img src={RotoGPT} alt="RotoGPT" width={100} />
            </a>
          </Box>
          <Box sx={{ display: { sm: "none", lg: "block", xs: "none" } }}>
            {/* AGREGAR external LUEGO DE LABEL,PATH CUANDO SE AGREGUE API DOCS */}
            {navItems.map(({ label, path }) => (
              //AGREGAR EXTERNAL CUANDO SE AGREGUE API DOCS COMO PARAMETRO EN handleNavClick LUEGO DE PATH
              <Button key={label} sx={{ p: 1, color: "#ffffff", fontFamily: "Roboto,Arial" }} onClick={() => handleNavClick(path)}>
                {label}
              </Button>
            ))}
          </Box>

          <Box
            p={0}
            sx={{
              display: { sm: "block", lg: "none" },
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            <a href="/">
              <img src={RotoGPT} alt="RotoGPT" width={100} />
            </a>
          </Box>

          <Box sx={{ display: "flex" }}>
            {/* DESCOMENTAR CUANDO SE AGREGUE DASHBOARD/LOGIN DE NUEVO */}

            {/* <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => {
                isAuthenticated ? navigate("/dashboard/home") : login();
              }}
              sx={{ fontFamily: "Roboto, Arial", width: "83px", ml: 1, fontSize: { lg: "13px", xs: "11px" } }}
            >
              {isAuthenticated ? "Dashboard" : "Log in"}
            </Button> */}
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { sm: "block", lg: "none" },
            "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}
